import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../../../core/Evented.js";
import t from "../../../../../core/has.js";
import { r as s } from "../../../../../chunks/rbush.js";
import { Tile as i } from "./Tile.js";
import o from "../../../tiling/TileCoverage.js";
import h from "../../../tiling/TileKey.js";
var n = {
  added: [],
  removed: []
},
    r = new Set(),
    d = new h(0, 0, 0, 0);

var l = /*#__PURE__*/function (_e) {
  _inherits(l, _e);

  var _super = _createSuper(l);

  function l(e) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this), _this._tiles = new Map(), _this._index = s(9, t("esri-csp-restrictions") ? function (e) {
      return {
        minX: e.bounds[0],
        minY: e.bounds[1],
        maxX: e.bounds[2],
        maxY: e.bounds[3]
      };
    } : [".bounds[0]", ".bounds[1]", ".bounds[2]", ".bounds[3]"]), _this.tiles = [], _this.tileScheme = e;
    return _this;
  }

  _createClass(l, [{
    key: "destroy",
    value: function destroy() {
      this.clear();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.tiles.length = 0, this._tiles.clear(), this._index.clear();
    }
  }, {
    key: "has",
    value: function has(e) {
      return this._tiles.has(e);
    }
  }, {
    key: "get",
    value: function get(e) {
      return this._tiles.get(e);
    }
  }, {
    key: "boundsIntersections",
    value: function boundsIntersections(e) {
      return this._index.search({
        minX: e[0],
        minY: e[1],
        maxX: e[2],
        maxY: e[3]
      });
    }
  }, {
    key: "updateTiles",
    value: function updateTiles(e) {
      var _this2 = this;

      var t = {
        added: [],
        removed: []
      };

      var _iterator = _createForOfIteratorHelper(e.added),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _s = _step.value;

          if (!this.has(_s)) {
            var _e2 = new i(this.tileScheme, _s);

            this._tiles.set(_s, _e2), this._index.insert(_e2), t.added.push(_e2);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(e.removed),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _s2 = _step2.value;

          if (this.has(_s2)) {
            var _e3 = this.get(_s2);

            this._tiles.delete(_s2), this._index.remove(_e3), t.removed.push(_e3);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.tiles.length = 0, this._tiles.forEach(function (e) {
        return _this2.tiles.push(e);
      }), (t.added.length || t.removed.length) && this.emit("update", t);
    }
  }, {
    key: "setViewState",
    value: function setViewState(e) {
      var t = this.tileScheme.getTileCoverage(e, 0);
      if (!t) return;
      var s = t.spans,
          h = t.lodInfo,
          _l = h.level;

      if (s.length > 0) {
        var _iterator3 = _createForOfIteratorHelper(s),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _step3.value,
                _o = _step3$value.row,
                a = _step3$value.colFrom,
                m = _step3$value.colTo;

            for (var _e4 = a; _e4 <= m; _e4++) {
              var _t = d.set(_l, _o, h.normalizeCol(_e4), h.getWorldForColumn(_e4)).id;

              if (r.add(_t), !this.has(_t)) {
                var _e5 = new i(this.tileScheme, _t);

                this._tiles.set(_t, _e5), this._index.insert(_e5), this.tiles.push(_e5), n.added.push(_e5);
              }
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      for (var _i = this.tiles.length - 1; _i >= 0; _i--) {
        var _e6 = this.tiles[_i];
        r.has(_e6.id) || (this._tiles.delete(_e6.id), this.tiles.splice(_i, 1), this._index.remove(_e6), n.removed.push(_e6));
      }

      (n.added.length || n.removed.length) && this.emit("update", n), o.pool.release(t), r.clear(), n.added.length = 0, n.removed.length = 0;
    }
  }]);

  return l;
}(e);

export { l as default };